import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {PAGES_AND_PATHS} from '../constants/pages-and-paths';
import {AuthenticationHelperService} from '../services/helpers/authentication-helper.service';
import {ActivePageHelperService} from '../services/helpers/active-page-helper.service';
import {Platform} from '@angular/cdk/platform';
import {UserRoles} from "../enums/general-enums";


@Injectable()
export class AuthGuardService {

  constructor(
    public authHelperService: AuthenticationHelperService,
    private router: Router,
    private activePageHelper: ActivePageHelperService,
    private platform: Platform
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): boolean {
    if (!this.platform.isBrowser) {
      return true;  // Allow navigation on the server side
    }
    if (!this.authHelperService.isAuthenticated) {
      this.router.navigate([PAGES_AND_PATHS.selectLanguage.pagePath]);
      // (localStorage.getItem('user_lang') !== 'undefined')
      //   ? this.router.navigate([PAGES_AND_PATHS.login.pagePath])
      //   : this.router.navigate([PAGES_AND_PATHS.selectLanguage.pagePath]);
    }
    if (route.data && route.data.data) {
      this.activePageHelper.activePage = route.data.data;
    }

    if (this.authHelperService.isAuthenticated && this.authHelperService.getUserData.email_verified_at === null && route.data.data.pageInRouting !== PAGES_AND_PATHS.verifyAccountCompany.pageInRouting && route.data.data.pageInRouting !== PAGES_AND_PATHS.verifyAccount.pageInRouting) {
      this.router.navigate(this.authHelperService.getUserData.company_profile ? [PAGES_AND_PATHS.verifyAccountCompany.pagePath] : [PAGES_AND_PATHS.verifyAccount.pagePath]);
      return false;
    }

    if (this.authHelperService.isAuthenticated && this.authHelperService.getUserData.email_verified_at !== null && this.authHelperService.getUserData.company_profile && route.data.data.pageInRouting !== PAGES_AND_PATHS.companySubscription.pageInRouting) {
      if (this.authHelperService.checkActiveSubscription(this.authHelperService.getUserData.subscriptions) !== UserRoles.company) {
        this.router.navigate([PAGES_AND_PATHS.companySubscription.pagePath]);
        return false;
      }
    }

    return this.authHelperService.isAuthenticated;
  }
}
